import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row, Table } from "react-bootstrap";
import Select from "react-select";

import ImageViewer from "../../components/ImageViewer";
import { useParams } from "react-router-dom";
import { getExpenseRequestDetails } from "../../services/contractorApi";
import { Helmet } from "react-helmet";
import CardComponent from "../../components/CardComponent";
import { useTranslation } from "react-i18next";
import { getPreviousFundRequestById } from "../../services/contractorApi";
import { getFundRequestById } from "../../services/contractorApi";
import { Badge } from "react-bootstrap";
import { formatAmountINR, to3 } from "../../utils/helper";
import { PunchItemRemarksCell, usePunchRequestRemarks } from "../../components/ItemRemarks";



export const ViewExpenseRequest = () => {
  const params = useParams();
  console.log("ALL PARAMS:", params);
  const id = params.id;
  const fund_id = params.fund_id;
  // each item's earlier remarks (Request / Approve / Transfer) from the
  // employee's open requests, shown in the items tables' Remarks column
  const punchRemarks = usePunchRequestRemarks("fund", { userId: id });

  const [edit, setEdit] = useState({});

  let currentDate = new Date();
  const { t } = useTranslation();
  const [previousFundAmount, setPreviousFundAmount] = useState(0);
  const [previousFundAmountData, setPreviousFundAmountData] = useState([]);
  const [expenseRequestDetails, setRequestDetails] = useState([]);


  function isEmpty(obj) {
    for (var key in obj) {
      if (obj.hasOwnProperty(key)) return false;
    }
    return true;
  }

  const months = [
    {
      label: "January",
      value: "1",
    },
    {
      label: "February",
      value: "2",
    },
    {
      label: "March",
      value: "3",
    },
    {
      label: "April",
      value: "4",
    },
    {
      label: "May",
      value: "5",
    },
    {
      label: "June",
      value: "6",
    },
    {
      label: "July",
      value: "7",
    },
    {
      label: "August",
      value: "8",
    },
    {
      label: "September",
      value: "9",
    },
    {
      label: "October",
      value: "10",
    },
    {
      label: "November",
      value: "11",
    },
    {
      label: "December",
      value: "12",
    },
  ];

  const getDate = (inputDate) => {
    if (inputDate) {
      const [year, month] = inputDate.split("-");
      const date = new Date(`${month}-01-${year}`);
      const formattedDate = new Intl.DateTimeFormat("en-US", {
        month: "long",
        year: "numeric",
      }).format(date);

      return formattedDate;
    }
  };

  const [item, setItems] = useState([]);
  // const [item, setItems] = useState({});
  const [month, setMonth] = useState(
    findMonthByValue(currentDate.getMonth() + 1)
  );

  const currentYear = currentDate.getFullYear();
  const yearOptions = Array.from({ length: 5 }, (_, i) => {
    const y = currentYear - i;
    return { label: String(y), value: String(y) };
  });
  const [year, setYear] = useState({ label: String(currentYear), value: String(currentYear) });


  useEffect(() => {
    if (params.id) getAllExpenseRequest();
    fetchSingleData(params.fund_id);
  }, [month, year]);

  useEffect(() => {
    getPreviousFundRequestDetails(params.id, "null");
    // getpunchrequestitemdetails(edit?.request_for_id);
    fetchSingleData(params.fund_id);
  }, []);

  const fetchSingleData = async () => {
    const res = await getFundRequestById(fund_id);
    if (res.status) {
      setEdit(res.data);
      getPreviousFundRequestDetails(res.data?.request_for_id, id);
      // fetchAllPreviousItem(res.data?.request_for_id);
    } else {
      setEdit({});
    }
  };

  const getPreviousFundRequestDetails = async (id, requestId) => {
    const res = await getPreviousFundRequestById(id, requestId);
    if (res.status) {
      setPreviousFundAmount(res?.finalBalance);
      setPreviousFundAmountData(res?.data);
    } else {
      setPreviousFundAmount(0);
    }
  };

  const getAllExpenseRequest = async () => {
    const res = await getExpenseRequestDetails(params?.id, month.value, year.value);
    console.log("param id:", params.id, typeof params.id);
    console.log("EXPENSE SUMMARY API:", res);
    setItems(res.data);
  };

  let statusColor = "";
  let statusText = "";

  switch (+item?.status) {
    case 0:
      statusColor = "#D9512C"; // Pending
      statusText = "Pending";
      break;
    case 1:
      statusColor = "green"; // Approved
      statusText = "Approved";
      break;
    case 2:
      statusColor = "red"; // Reject
      statusText = "Rejected";
      break;
    case 3:
      statusColor = "orange"; // Hold
      statusText = "On Hold";
      break;
    case 4:
      statusColor = "blue"; // Partial
      statusText = "Partial";
      break;
    case 5:
      statusColor = "green"; // Done
      statusText = "Done";
      break;
  }

  function findMonthByValue(value) {
    for (let i = 0; i < months.length; i++) {
      if (months[i].value == value) {
        return months[i];
      }
    }
    return null;
  }

  return (
    <Col md="12">
      <Helmet>
        <title>Expense Request · CMS Electricals</title>
      </Helmet>
      <CardComponent showCardHeader={true} title={"All Expense Request"}>
        <Row className="g-3">
          {/* Left: User Details */}
          <Col md={6}>
            <div className="p-20 shadow rounded h-100">
              <strong className="text-secondary">
                {t("Request By Details")}
              </strong>
              <div className="mt-2">
                <table className="table-sm table">
                  <tbody>
                    <tr>
                      <th>{t("Username")} :</th>
                      <td>
                        <div>
                          <div style={{ fontWeight: 600 }}>
                            {item?.users?.[0]?.name || previousFundAmountData?.[0]?.user_name || "--"}
                          </div>
                          {item?.users?.[0]?.employee_id && (
                            <div style={{ fontSize: "11px", color: "blue" }}>
                              ({item?.users?.[0]?.employee_id})
                            </div>
                          )}
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th>{t("Status")} :</th>
                      <td>
                        <Badge
                          bg={edit?.status === 1 ? "success" : "secondary"}
                          className="fw-normal"
                          style={{ fontSize: 11 }}
                        >
                          {edit?.status === 1 ? "Active" : "Not Active"}
                        </Badge>
                      </td>
                    </tr>
                    <tr>
                      <th>{t("Current Balance")} :</th>
                      <td style={{ color: "green", fontWeight: "600" }}>
                        {formatAmountINR(edit?.user_balance ?? 0)}
                      </td>
                    </tr>
                    <tr>
                      <th>{t("Current Month Balance")} :</th>
                      <td style={{ color: "green", fontWeight: "600" }}>
                        {formatAmountINR(item?.currentMonth?.overallTotalSum ?? 0)}
                      </td>
                    </tr>
                    <tr>
                      <th>{t("Previous Month Balance")} :</th>
                      <td style={{ color: "green", fontWeight: "600" }}>
                        {formatAmountINR(item?.previousMonth?.overallTotalSum ?? 0)}
                      </td>
                    </tr>
                    {/* <tr>
                      <th>{t("Requested Punched Qty")} :</th>
                      <td style={{ color: "green", fontWeight: "600" }}>
                        {item?.currentMonth?.items
                          ? Object.values(item.currentMonth.items).reduce(
                              (sum, main) =>
                                sum +
                                main.data.reduce(
                                  (s, itm) =>
                                    s + (Number(itm?.expense_request_quantity) || 0),
                                  0
                                ),
                              0
                            )
                          : "0"}
                      </td>
                    </tr> */}
                  </tbody>
                </table>
              </div>
            </div>
          </Col>

          {/* Right: Fund & Punch Details */}
          <Col md={6}>
            <div className="p-20 shadow rounded h-100">
              <strong className="text-secondary">{t("Fund & Punch Details")}</strong>
              <div className="mt-2">
                <table className="table-sm table">
                  <tbody>
                    <tr>
                      <th>{t("For Month")} :</th>
                      <td>{month?.label}</td>
                    </tr>
                    <tr>
                      <th>{t("Total Fund Limit")} :</th>
                      <td style={{ color: "green", fontWeight: "600" }}>
                        {formatAmountINR(previousFundAmountData[0]?.fund_limit ?? 0)}
                      </td>
                    </tr>
                    <tr>
                      <th>{t("Total Fund Transferred")} :</th>
                      <td style={{ color: "green", fontWeight: "600" }}>
                        {formatAmountINR(previousFundAmountData[0]?.total_transfer_amount ?? 0)}
                      </td>
                    </tr>
                    <tr>
                      <th>{t("Total Amount Punched")} :</th>
                      <td style={{ color: "green", fontWeight: "600" }}>
                        {formatAmountINR(previousFundAmountData[0]?.total_amount_punched ?? 0)}
                      </td>
                    </tr>
                    <tr>
                      <th>{t("Remaining Fund Limit")} :</th>
                      <td style={{ color: "green", fontWeight: "600" }}>
                        {formatAmountINR(
                          (previousFundAmountData[0]?.fund_limit ?? 0) -
                            ((previousFundAmountData[0]?.total_transfer_amount ?? 0) -
                              (previousFundAmountData[0]?.total_amount_punched ?? 0))
                        )}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </Col>
        </Row>

        <Row className="my-3 justify-content-end ">
          <Form.Group as={Col} md={3}>
            <Select
              placeholder="Select Month"
              menuPortalTarget={document.body}
              options={months}
              onChange={(e) => setMonth(e)}
              value={month}
            />
          </Form.Group>
          <Form.Group as={Col} md={3}>
            <Select
              placeholder="Select Year"
              menuPortalTarget={document.body}
              options={yearOptions}
              onChange={(e) => setYear(e)}
              value={year}
            />
          </Form.Group>
        </Row>

        {/* {item && (
          <Col md={12} className="my-3">
            <div className="p-20 shadow rounded h-100">
              <strong className="text-secondary">{t("Expense Fund")}</strong>
              <div className="mt-2">
                <table className="table-sm table">
                  <tbody>
                    <tr>
                      <th>{t("Name")} :</th>
                      <td style={{ color: statusColor }}>
                        {item?.users?.[0]?.name}
                      </td>
                    </tr>

                    <tr>
                      <th>{t("For Month")} :</th>
                      <td>{month?.label}</td>
                    </tr>

                    <tr>
                      <th>{t("total Amount")} :</th>
                      <td className="text-green">
                        ₹ {item?.currentMonth?.overallTotalSum}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </Col>
        )} */}

        <Col md={12} className="my-3">
          <div className="p-20 shadow rounded h-100">
            <strong className="text-secondary">{t("Fund Transfer Items List")}</strong>
            <div className="table-scroll mt-2" style={{ maxHeight: "400px", overflowY: "auto" }}>
              <Table className="table-sm table Roles" style={{ fontSize: "13px" }}>
                <thead style={{ position: "sticky", top: 0, background: "#fff", zIndex: 1 }}>
                  <tr>
                    <th style={{ minWidth: "50px" }}>{t("Sr No.")}</th>
                    <th style={{ minWidth: "200px" }}>{t("Item Name")}</th>
                    <th style={{ minWidth: "220px" }}>{t("Remarks")}</th>
                    <th style={{ minWidth: "100px" }}>{t("Transferred Qty")}</th>
                    <th style={{ minWidth: "100px" }}>{t("Item Price")}</th>
                    <th style={{ minWidth: "100px" }}>{t("Total")}</th>
                    <th style={{ minWidth: "120px" }}>{t("Amount Punched")}</th>
                    <th style={{ minWidth: "130px" }}>{t("Remaining Amount")}</th>
                  </tr>
                </thead>
                <tbody>
                  {!isEmpty(item?.currentMonth?.items) ? (
                    Object.values(item?.currentMonth?.items).map(
                      (main, index) => {
                        const itm = main.data[0];
                        return (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>
                              <div className="d-flex align-items-center">
                                <ImageViewer
                                  src={
                                    itm.item_images
                                      ? process.env.REACT_APP_API_URL + itm.item_images
                                      : `${process.env.REACT_APP_API_URL}/assets/images/default-image.png`
                                  }
                                >
                                  <img
                                    src={
                                      itm.item_images
                                        ? process.env.REACT_APP_API_URL + itm.item_images
                                        : `${process.env.REACT_APP_API_URL}/assets/images/default-image.png`
                                    }
                                    className="avatar me-2"
                                  />
                                </ImageViewer>
                                <span className="small d-grid">
                                  <span>{itm?.item_name || itm?.new_item}</span>
                                  <span className="text-gray" style={{ fontSize: "11px" }}>
                                    {itm.item_unique_id ? `(${itm.item_unique_id})` : "-"}
                                  </span>
                                </span>
                              </div>
                            </td>
                            <td>
                              <PunchItemRemarksCell
                                remarks={punchRemarks}
                                itemName={itm?.item_name || itm?.new_item}
                                canEdit
                              />
                            </td>
                            <td>{itm?.transfer_qty != null ? to3(itm.transfer_qty) : "--"}</td>
                            <td>{itm?.item_price != null ? formatAmountINR(itm.item_price) : "--"}</td>
                            <td>{main?.totalSum != null ? formatAmountINR(main.totalSum) : "--"}</td>
                            <td>{formatAmountINR(itm?.expense_transfer_amounts ?? 0)}</td>
                            <td>{main?.remainingAmount != null ? formatAmountINR(main.remainingAmount) : "--"}</td>
                          </tr>
                        );
                      }
                    )
                  ) : (
                    <tr>
                      <td colSpan={8} className="text-center">
                        <img
                          className="p-3"
                          alt="no-result"
                          width="200"
                          src={`${process.env.REACT_APP_API_URL}/assets/images/no-results.png`}
                        />
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
          </div>
        </Col>

        <Col md={12} className="my-3">
          <div className="p-20 shadow rounded h-100">
            <strong className="text-secondary">
              {t("Fund Transfer Item List of Previous Month")}
            </strong>
            <div className="table-scroll mt-2" style={{ maxHeight: "400px", overflowY: "auto" }}>
              <Table className="table-sm table Roles" style={{ fontSize: "13px" }}>
                <thead style={{ position: "sticky", top: 0, background: "#fff", zIndex: 1 }}>
                  <tr>
                    <th style={{ minWidth: "50px" }}>{t("Sr No.")}</th>
                    <th style={{ minWidth: "200px" }}>{t("Item Name")}</th>
                    <th style={{ minWidth: "220px" }}>{t("Remarks")}</th>
                    <th style={{ minWidth: "100px" }}>{t("Transferred Qty")}</th>
                    <th style={{ minWidth: "100px" }}>{t("Item Price")}</th>
                    <th style={{ minWidth: "100px" }}>{t("Total")}</th>
                    <th style={{ minWidth: "120px" }}>{t("Amount Punched")}</th>
                    <th style={{ minWidth: "130px" }}>{t("Remaining Amount")}</th>
                  </tr>
                </thead>
                <tbody>
                  {!isEmpty(item?.previousMonth?.items) ? (
                    Object.values(item?.previousMonth?.items).map(
                      (main, index) => {
                        const itm = main.data[0];
                        return (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>
                              <div className="d-flex align-items-center">
                                <ImageViewer
                                  src={
                                    itm.item_images
                                      ? process.env.REACT_APP_API_URL + itm.item_images
                                      : `${process.env.REACT_APP_API_URL}/assets/images/default-image.png`
                                  }
                                >
                                  <img
                                    src={
                                      itm.item_images
                                        ? process.env.REACT_APP_API_URL + itm.item_images
                                        : `${process.env.REACT_APP_API_URL}/assets/images/default-image.png`
                                    }
                                    className="avatar me-2"
                                  />
                                </ImageViewer>
                                <span className="small d-grid">
                                  <span>{itm?.item_name || itm?.new_item}</span>
                                  <span className="text-gray" style={{ fontSize: "11px" }}>
                                    {itm.item_unique_id ? `(${itm.item_unique_id})` : "-"}
                                  </span>
                                </span>
                              </div>
                            </td>
                            <td>
                              <PunchItemRemarksCell
                                remarks={punchRemarks}
                                itemName={itm?.item_name || itm?.new_item}
                                canEdit
                              />
                            </td>
                            <td>{itm?.transfer_qty != null ? to3(itm.transfer_qty) : "--"}</td>
                            <td>{itm?.item_price != null ? formatAmountINR(itm.item_price) : "--"}</td>
                            <td>{main?.totalSum != null ? formatAmountINR(main.totalSum) : "--"}</td>
                            <td>{formatAmountINR(itm?.expense_transfer_amounts ?? 0)}</td>
                            <td>{main?.remainingAmount != null ? formatAmountINR(main.remainingAmount) : "--"}</td>
                          </tr>
                        );
                      }
                    )
                  ) : (
                    <tr>
                      <td colSpan={8} className="text-center">
                        <img
                          className="p-3"
                          alt="no-result"
                          width="200"
                          src={`${process.env.REACT_APP_API_URL}/assets/images/no-results.png`}
                        />
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
          </div>
        </Col>
      </CardComponent>
    </Col>
  );
};
